module.exports = __webpack_public_path__ + "img/Hypoxia-MELA_GSE185386.451db0ca.png";